import React from 'react';
import * as PageContainer from "../pages";
import { routesPaths } from "./routesPaths";
import { Redirect } from 'react-router-dom';

export function menuRoutes(appContextData) {
    const t = appContextData.i18n.t;
    let routes = [];

    if (t) {
        const enabledModules = (appContextData.enabledModules || "").split(',').map(m => m.trim()).filter(Boolean);

        const paymentHub = {
            path: routesPaths.paymentHub,
            name: t("titleCase.menuTransactions", { count: 1 }),
            id: "statistics",
            component: PageContainer.SepaStatistics,
            routes: []
        };

        const sdd = {
            path: routesPaths.bulkSdd,
            name: t("titleCase.debit", { count: 1 }),
            id: "sdd",
            component: () => <Redirect to={routesPaths.bulkSdd_sub} />,
            sub: [ // Qui stiamo aggiungendo un sottomenu
                {
                    path: routesPaths.bulkSdd_sub,
                    name: t("titleCase.bulksdd", { count: 1 }),
                    id: "bulk",
                    component: PageContainer.Bulk
                },
                {
                    path: routesPaths.debitSdd,
                    name: t("titleCase.debit", { count: 1 }),
                    id: "debit",
                    component: PageContainer.DebitSdd
                },
                {
                    path: routesPaths.downloadSdd,
                    name: t("titleCase.file", { count: 1 }),
                    id: "fileSdd",
                    component: PageContainer.DownloadSdd
                }
            ]
        };

        const sct = {
            path: routesPaths.bulkSct,
            name: t("titleCase.menuSctSearch", { count: 1 }),
            id: "sct",
            component: () => <Redirect to={routesPaths.bulkSct_sub} />,
            sub: [ // Qui stiamo aggiungendo un sottomenu
                {
                    path: routesPaths.bulkSct_sub,
                    name: t("titleCase.bulksct", { count: 1 }),
                    id: "bulk",
                    component: PageContainer.BulkSCT
                },
                {
                    path: routesPaths.sct,
                    name: t("titleCase.menuSctSearch", { count: 1 }),
                    id: "credit",
                    component: PageContainer.Sct
                },
                {
                    path: routesPaths.downloadSct,
                    name: t("titleCase.file", { count: 1 }),
                    id: "fileSct",
                    component: PageContainer.DownloadSct
                }
            ]
        };

        const digitalSignature = {
            path: routesPaths.approvalSct, // puoi usare uno dei path come default
            name: t("titleCase.menuDigitalSignature", { count: 1 }),
            id: "digitalSignature",
            component: () => <Redirect to={routesPaths.approvalSct} />,
            sub: []
        };

        if (enabledModules.includes("CONFIGURATION")) {
            paymentHub.routes.push({
                path: routesPaths.paymentHubConfiguration,
                name: t("titleCase.configurations", { count: 1 }),
                id: "configuration",
                component: PageContainer.Configuration
            });
        }

        // add STATISTICS route when module enabled
        if (enabledModules.includes("STATISTICS")) {
            paymentHub.routes.push({
                path: routesPaths.paymentHub,
                name: t("titleCase.menuStatistic", { count: 1 }),
                id: "statistics",
                component: PageContainer.SepaStatistics
            });
        }

        // add signature-related subpages conditionally and add digitalSignature parent if any are present
        if (enabledModules.includes("SIGNATURE")) {
            digitalSignature.sub.push({
                path: routesPaths.approvalSct,
                name: t("titleCase.menuApprovalSct", { count: 1 }),
                id: "approvalSct",
                component: PageContainer.ApprovalSct
            });
            digitalSignature.sub.push({
                path: routesPaths.signatureSct,
                name: t("titleCase.menuSignSct", { count: 1 }),
                id: "signSct",
                component: PageContainer.SignatureSct
            });
        }
        if (enabledModules.includes("SIGNATURE_USERS")) {
            digitalSignature.sub.push({
                path: routesPaths.signatureUser,
                name: t("titleCase.menuSignatureUser", { count: 1 }),
                id: "signatureUser",
                component: PageContainer.SignatureUser
            });
        }
        if (enabledModules.includes("SIGNATURE_PROFILES")) {
            digitalSignature.sub.push({
                path: routesPaths.signatureProfiles,
                name: t("titleCase.menuSignatureProfiles", { count: 1 }),
                id: "signatureProfiles",
                component: PageContainer.SignatureProfiles
            });
        }

        if (enabledModules.includes("SDD") || enabledModules.includes("SCT") || enabledModules.includes("SIGNATURE") || enabledModules.includes("SIGNATURE_USERS") || enabledModules.includes("SIGNATURE_PROFILES") || enabledModules.includes("STATISTICS") || enabledModules.includes("CONFIGURATION")) {
            if (enabledModules.includes("SCT")) {
                paymentHub.routes.push(sct);
            }
            if (enabledModules.includes("SDD")) {
                paymentHub.routes.push(sdd);
            }
            routes.push(paymentHub);
        }

        if (digitalSignature.sub.length > 0) {
            paymentHub.routes.push(digitalSignature);
        }

        const routesOrder = [paymentHub.name];

        let newRoutes = routesOrder.map(el => routes.find(element => element.name === el) || {});
        routes = newRoutes.filter(value => Object.keys(value).length !== 0);
    }

    return routes;
}
